import { useCallback } from 'react'

import useWebinarAppState from '../../Webinar/providers/WebinarAppStateProvider'

import useSimplePubSubMessage from './useSimplePubSubMessage'

export default function useWebinarPrivateChannel<T>(
  channel: string,
  onMessage?: (message: T) => void
) {
  const { privateChannelURL } = useWebinarAppState()

  if (privateChannelURL === null) {
    throw new Error(
      'useWebinarPrivateChannel must be used after setting privateChannelURL'
    )
  }

  const channelWithSlash = !channel.startsWith('/') ? `/${channel}` : channel
  const channelAppended = `${privateChannelURL}${channelWithSlash}`

  const handleMessage = useCallback(
    (message: string) => {
      onMessage!(JSON.parse(message))
    },
    [onMessage]
  )

  return useSimplePubSubMessage<string>(
    channelAppended,
    onMessage !== undefined ? handleMessage : undefined
  )
}
